export default __webpack_public_path__ + "static/media/global.98b2295a.svg";